export default __webpack_public_path__ + "static/media/trash_icon.ab631ef7.svg";